import React from "react";

/** Tiny label always visible + richer hint on hover/focus (touch: label only). */
export default function HintTip({ label, hint, children, block }) {
  return (
    <span
      className={`hint-tip-wrap${block ? " hint-tip-block" : ""}`}
      title={hint || label}
    >
      {children}
      <span className="hint-tip-label">{label}</span>
      {hint && hint !== label && (
        <span className="hint-tip-popup" role="tooltip">
          {hint}
        </span>
      )}
    </span>
  );
}
